// extracted by mini-css-extract-plugin
export default {"pages-search-bar":"PagesSearchBar_pages-search-bar__Dc7Vx","pagesSearchBar":"PagesSearchBar_pages-search-bar__Dc7Vx"};